import * as React from "react";
import { ChevronRight, Home } from "lucide-react";

type BreadcrumbProps = {
  folderPath: string;
  onNavigate: (path: string) => void;
};

export function Breadcrumb({ folderPath, onNavigate }: BreadcrumbProps) {
  const segments = folderPath ? folderPath.split("/").filter(Boolean) : [];

  const breadcrumbItems = [
    { name: "Home", path: "" },
    ...segments.map((segment, index) => ({
      name: segment,
      path: segments.slice(0, index + 1).join("/"),
    })),
  ];

  return (
    <nav className="flex items-center gap-1 text-sm">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={item.path}>
          {index > 0 && <ChevronRight className="size-4 text-muted-foreground" />}
          <button
            onClick={() => onNavigate(item.path)}
            className={`flex items-center gap-1 rounded px-2 py-1 transition-colors hover:bg-accent ${
              index === breadcrumbItems.length - 1
                ? "font-medium text-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {index === 0 && <Home className="size-4" />}
            {item.name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}
